import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LottieComponent } from 'ngx-lottie';
import type { AnimationOptions } from 'ngx-lottie';
import { GlobalLoaderService } from './core/loading/global-loader.service';
import loaderAnimation from '../assets/loader.json';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, LottieComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  protected readonly loader = inject(GlobalLoaderService);

  /**
   * Bundled animation (not fetched by URL) so Lottie re-renders reliably
   * every time the overlay is created (e.g. after navigation back).
   */
  protected readonly lottieOptions: AnimationOptions = {
    animationData: loaderAnimation,
    loop: true,
  };
}
